query payCycleSearch(
  $first: Int
  $after: Cursor
  $filter: PayCycleFilter
  $orderBy: [PayCyclesOrderBy!]
  $searchRequest: SearchRequestInput
  $isHistorySearch: Boolean
  $isLinkSearch: Boolean
  $isSigningSearch: Boolean
) {
  payCycleSearch(
    first: $first
    after: $after
    filter: $filter
    orderBy: $orderBy
    searchRequest: $searchRequest
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
  ) {
    nodes {
      id
      __typename
      _urgencyLevel
      _rowTimestamp
      _pendingApprovers
      transactionType {
        description
        layoutType
        transactionType
      }
      _isAccountingEntry
      _isDeletable
      paymentAccountId
      paymentAccount {
        name
        bankAccountNumber
      }
      description
      defaultPaymentDate
      controlTotalAmount
      currency {
        isoCode
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _isTransactionCancelled
      _totalPayments
      _paymentCount
      businessUnit {
        name
      }
      corporatePeriodId
      _isStagedApprovalRequest
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
    aggregates {
      sum {
        _paymentCount
        _totalPayments
        controlTotalAmount
      }
    }
  }
}
